import React from "react";
import styles from "./MarketingPage.module.css";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import marketingMyFleetSvg from "../assets/marketingMyFleet.svg";
import marketingGrade from "../assets/marketingGrade.svg";
import marketingSubgrades from "../assets/marketingSubgrades.svg";
import marketingDefects from "../assets/marketingDefects.svg";
import marketingPsc from "../assets/marketingPsc.svg";
import marketingScreening from "../assets/marketingScreening.svg";
import idLogo from "../assets/idwal-id-logo.svg";

export interface MarketingPageProps {
    type: "myFleet" | "grade" | "subgrade" | "defects" | "psc" | "screening";
    learnMoreCallback: () => void;
    requestDemoCallback: () => void;
    showLogo: boolean;
}

export function MarketingPage(props: MarketingPageProps) {
    const { t } = useTranslation("common");

    const getTranslationText = (key: string) => t(key);

    let headerLocaleKey;
    let contentLocaleKey;
    let marketingImage;

    switch (props.type) {
        case "myFleet":
            headerLocaleKey = "myFleetHeader";
            contentLocaleKey = "myFleetContent";
            marketingImage = marketingMyFleetSvg;
            break;
        case "grade":
            headerLocaleKey = "gradeHeader";
            contentLocaleKey = "gradeContent";
            marketingImage = marketingGrade;
            break;
        case "subgrade":
            headerLocaleKey = "subgradeHeader";
            contentLocaleKey = "subgradeContent";
            marketingImage = marketingSubgrades;
            break;
        case "defects":
            headerLocaleKey = "defectsHeader";
            contentLocaleKey = "defectsContent";
            marketingImage = marketingDefects;
            break;
        case "psc":
            headerLocaleKey = "pscHeader";
            contentLocaleKey = "pscContent";
            marketingImage = marketingPsc;
            break;
        case "screening":
            headerLocaleKey = "screeningHeader";
            contentLocaleKey = "screeningContent";
            marketingImage = marketingScreening;
            break;
        default:
            headerLocaleKey = "myFleetHeader";
            contentLocaleKey = "myFleetContent";
            marketingImage = marketingMyFleetSvg;
            break;
    }

    return (
        <div className={`${styles.container} flex lg:flex-row flex-column`}>
            <div className={"flex flex-column h-full"}>
                <div className={"flex lg:flex-row flex-column"}>
                    {props.showLogo && (
                        <>
                            <img
                                className={`${styles.marketingIdLogo} lg:inline hidden`}
                                src={idLogo}
                            />
                            <p
                                className={`${styles.headerOne} lg:ml-3 lg:pl-0 pl-2 mb-3`}
                            >
                                {getTranslationText("marketingPage.unlock")}
                            </p>
                        </>
                    )}
                    {marketingImage && (
                        <img
                            className={"lg:hidden inline w-20rem mb-2"}
                            src={marketingImage}
                        />
                    )}
                </div>

                <div
                    className={
                        "flex flex-column align-items-center lg:pl-0 pl-2 mb-4"
                    }
                >
                    <h1
                        className={`lg:${styles.headerTwo} ${styles.headerTwoMobile} lg:w-full w-20rem mb-4`}
                    >
                        {getTranslationText(`marketingPage.${headerLocaleKey}`)}
                    </h1>
                    <p className={`${styles.content} lg:w-full w-20rem`}>
                        {getTranslationText(
                            `marketingPage.${contentLocaleKey}`
                        )}
                    </p>
                </div>
                <div className={`${styles.buttonContainer} lg:mt-8`}>
                    <Button
                        className={`${styles.leftButton} w-full lg:w-auto`}
                        onClick={() => {
                            props.requestDemoCallback();
                            window.open(
                                "https://www.idwalmarine.com/id/demo",
                                "_blank"
                            );
                        }}
                    >
                        <p className={styles.leftButtonText}>
                            {getTranslationText("marketingPage.rightButton")}
                        </p>
                    </Button>
                    <Button
                        className={`${styles.rightButton} w-full lg:w-auto`}
                        onClick={() => {
                            props.learnMoreCallback();
                            window.open(
                                "https://www.idwalmarine.com/id",
                                "_blank"
                            );
                        }}
                    >
                        <p className={styles.rightButtonText}>
                            {getTranslationText("marketingPage.leftButton")}
                        </p>
                    </Button>
                </div>
            </div>
            {marketingImage && (
                <img className={"lg:inline hidden"} src={marketingImage} />
            )}
        </div>
    );
}
